import type { Dictionary } from "./translations";

export const pt: Dictionary = {
  "meta.title": "AgentBuck - Compare preços de modelos de IA",
  "meta.description": "Compare os preços de API dos principais modelos de IA e estime os custos mensais com base no seu uso real de tokens.",
  "nav.prices": "Preços dos modelos",
  "nav.calculator": "Calculadora de custos",
  "nav.providers": "Provedores",
  "nav.guide": "Guia de preços",
  "nav.method": "Metodologia",
  "aria.home": "Página inicial do AgentBuck",
  "aria.language": "Selecionar idioma",
  "aria.navigation": "Navegação principal",
  "aria.breadcrumb": "Caminho de navegação",
  "aria.dark": "Ativar modo escuro",
  "aria.light": "Ativar modo claro",
  "title.dark": "Modo escuro",
  "title.light": "Modo claro",
  "hero.eyebrow": "Base de preços de APIs de IA",
  "hero.title": "Encontre o modelo de IA ideal para seu orçamento",
  "hero.subtitle": "Compare preços de entrada, saída e cache na mesma base e estime o custo mensal com seu uso real de tokens.",
  "stats.models": "Modelos comparáveis",
  "stats.providers": "Principais provedores",
  "stats.updated": "Dados atualizados",
  "common.loading": "Carregando",
  "notice.snapshot": "Os dados ao vivo estão indisponíveis. Exibindo os dados locais de 7 de setembro de 2026.",
  "common.retry": "Tentar novamente",
  "common.home": "Início",
  "common.models": "Modelos",
  "common.providers": "Provedores",
  "common.from": "A partir de",
  "common.viewAll": "Ver todos",
  "common.backPricing": "Voltar aos preços",
  "share.quick": "Compartilhar esta página",
  "share.kicker": "Compartilhe com sua equipe",
  "share.title": "Compartilhar esta comparação",
  "share.description": "Envie esta página com os modelos e as premissas de uso exatos.",
  "share.copy": "Copiar link",
  "share.copied": "Link copiado",
  "share.more": "Compartilhar",
  "share.openComparison": "Abrir página compartilhada",
  "share.email": "E-mail",
  "calculator.title": "Calculadora de custo mensal",
  "calculator.input": "Entrada mensal",
  "calculator.output": "Saída mensal",
  "calculator.cache": "Proporção de entrada em cache",
  "calculator.million": "milhões de tokens",
  "calculator.cheapest": "Os 5 modelos mais baratos agora",
  "calculator.perMonth": "Estimativa / mês",
  "prices.title": "Preços dos modelos",
  "prices.subtitle": "API padrão em tempo real, USD por milhão de tokens",
  "filter.open": "Filtros",
  "filter.search": "Buscar modelos ou provedores",
  "filter.clearSearch": "Limpar busca",
  "filter.provider": "Filtrar por provedor",
  "filter.allProviders": "Todos os provedores",
  "filter.sort": "Ordenar modelos",
  "filter.favorite": "Salvos",
  "sort.monthly": "Custo mensal estimado",
  "sort.input": "Preço de entrada",
  "sort.output": "Preço de saída",
  "sort.context": "Janela de contexto",
  "sort.newest": "Lançamentos recentes",
  "cap.reasoning": "Raciocínio",
  "cap.tools": "Chamadas de ferramentas",
  "cap.vision": "Visão",
  "cap.structured": "Saída estruturada",
  "cap.openWeights": "Pesos abertos",
  "results.found": "{count} modelos encontrados",
  "results.source": "Tarifas normalizadas a partir de preços publicados. Consulte a documentação do provedor para confirmar.",
  "column.compare": "Comparar",
  "column.model": "Modelo / provedor",
  "column.input": "Entrada",
  "column.cached": "Entrada em cache",
  "column.output": "Saída",
  "column.monthly": "Estimativa mensal",
  "column.context": "Contexto",
  "column.capabilities": "Raciocínio  Ferram.  Visão",
  "column.actions": "Ações",
  "action.officialDocs": "Documentação oficial",
  "action.addCompare": "Adicionar à comparação",
  "action.removeCompare": "Remover da comparação",
  "action.addFavorite": "Salvar modelo",
  "action.removeFavorite": "Remover modelo salvo",
  "action.added": "Adicionado",
  "context.suffix": "de contexto",
  "empty.title": "Nenhum modelo encontrado",
  "empty.description": "Tente outra busca ou remova os filtros de recursos.",
  "empty.clear": "Limpar filtros",
  "home.exploreKicker": "Explore o catálogo",
  "home.exploreTitle": "Mais formas de comparar modelos de IA",
  "home.providersTitle": "Explorar por provedor",
  "home.providersBody": "Compare todos os modelos disponíveis de OpenAI, Anthropic, Google, DeepSeek, Alibaba e outros.",
  "home.guideTitle": "Leia o guia de preços",
  "home.guideBody": "Entenda a distribuição de tokens, o cache de prompts, as faixas de contexto e o que altera a conta final da API.",
  "home.open": "Abrir",
  "providers.kicker": "Diretório de provedores",
  "providers.title": "Provedores de modelos de IA",
  "providers.intro": "Consulte preços de API normalizados, limites de contexto e recursos dos principais provedores do catálogo AgentBuck.",
  "providers.models": "{count} modelos",
  "providers.starting": "Menor tarifa de entrada",
  "providers.view": "Ver provedor",
  "provider.kicker": "Preços do provedor",
  "provider.titleSuffix": "Preços de API",
  "provider.description": "Compare {count} modelos de {name} por preço de entrada, preço de saída, janela de contexto e recursos para produção.",
  "provider.cheapest": "Entrada mais barata",
  "provider.largestContext": "Maior contexto",
  "provider.updated": "Catálogo atualizado",
  "model.kicker": "Detalhes de preços do modelo",
  "model.title": "Preços de API de {name}",
  "model.descriptionFallback": "Compare tarifas de tokens da API, limites de contexto, recursos e custo mensal estimado deste modelo.",
  "model.input": "Entrada / 1M de tokens",
  "model.cache": "Entrada em cache / 1M",
  "model.output": "Saída / 1M de tokens",
  "model.context": "Janela de contexto",
  "model.maxOutput": "Saída máxima",
  "model.released": "Lançamento",
  "model.updated": "Modelo atualizado",
  "model.estimateTitle": "Sua estimativa mensal",
  "model.estimateBody": "Com base em {input}M de entrada, {output}M de saída e {cache}% de entrada em cache.",
  "model.relatedTitle": "Mais modelos de {provider}",
  "compare.pageTitle": "Comparação compartilhada de custos de IA",
  "compare.pageBody": "Compare tarifas de tokens, janelas de contexto, recursos e custo mensal com as premissas salvas nesta URL.",
  "compare.emptyTitle": "Nenhum modelo nesta comparação",
  "compare.emptyBody": "Escolha dois ou três modelos na tabela de preços para criar uma comparação compartilhável.",
  "compare.start": "Escolher modelos",
  "compare.usage": "Carga de trabalho compartilhada",
  "notFound.title": "Página não encontrada",
  "notFound.body": "A página pode ter sido movida ou o modelo não está mais no catálogo atual.",
  "guide.kicker": "Guia prático de compra",
  "guide.title": "Compare preços de APIs de IA para sua carga de trabalho real",
  "guide.intro": "A menor tarifa de entrada nem sempre resulta na menor conta total. O AgentBuck combina custos de prompts, prompts em cache e tokens gerados para avaliar GPT, Claude, Gemini, DeepSeek, Qwen, Grok e outros modelos com a mesma carga de trabalho.",
  "guide.inputTitle": "Comece pela sua distribuição de tokens",
  "guide.inputBody": "Chatbots costumam consumir mais entrada do que saída. Agentes de programação e sistemas de raciocínio podem gerar muito mais saída, mudando o modelo de melhor custo-benefício.",
  "guide.cacheTitle": "Inclua o cache de prompts",
  "guide.cacheBody": "Prompts de sistema repetidos e contextos compartilhados longos podem tornar o preço de leitura do cache decisivo. Defina uma proporção de cache realista antes de comparar os totais mensais.",
  "guide.fitTitle": "Confira recursos e contexto",
  "guide.fitBody": "O preço só importa se o modelo atender às suas necessidades de contexto, entrada visual, raciocínio, saída estruturada e chamadas de ferramentas.",
  "faq.kicker": "Perguntas frequentes",
  "faq.title": "Perguntas sobre preços de modelos de IA",
  "faq.q1": "Como o AgentBuck compara os preços de APIs de modelos de IA?",
  "faq.a1": "O AgentBuck normaliza as tarifas padrão de APIs em tempo real para dólares por milhão de tokens e separa entrada, entrada em cache e saída. A documentação dos provedores está vinculada para verificação.",
  "faq.q2": "Qual modelo de IA tem a API mais barata?",
  "faq.a2": "Não existe um modelo mais barato em todos os casos. A resposta depende da proporção entre entrada e saída, do uso de cache e dos recursos necessários. Informe seu uso mensal acima para ordenar os modelos conforme sua carga de trabalho.",
  "faq.q3": "Como é calculado o custo mensal estimado de um LLM?",
  "faq.a3": "A estimativa multiplica os volumes de entrada sem cache, entrada em cache e saída pelas tarifas correspondentes de cada modelo. Impostos, descontos de lote, preços regionais e adicionais de contexto longo não estão incluídos.",
  "faq.q4": "Por que um modelo pode exibir preço de zero dólar?",
  "faq.a4": "Alguns provedores oferecem acesso gratuito ou promocional a modelos específicos. A disponibilidade e os limites podem mudar; verifique a documentação do provedor antes do uso em produção.",
  "faq.q5": "Os dados de preços estão atualizados?",
  "faq.a5": "O AgentBuck atualiza seu catálogo estruturado a cada seis horas. A tabela mostra a atualização de modelo mais recente da fonte, mas a cobrança real segue os termos do provedor.",
  "method.title": "Dados e metodologia",
  "method.priceTitle": "Base dos preços",
  "method.priceBody": "Tarifas padrão de API em tempo real em USD por milhão de tokens. Não incluem impostos, tarifas de lote, adicionais regionais ou faixas de contexto longo.",
  "method.sourceTitle": "Fonte dos dados",
  "method.sourceBefore": "Catálogos públicos de modelos e páginas de preços dos provedores são normalizados em um conjunto de dados comparável.",
  "method.sourceAfter": "O AgentBuck o atualiza a cada seis horas e inclui links para a documentação dos provedores.",
  "method.costTitle": "Estimativa de custo",
  "method.costBody": "Custo mensal = entrada normal + entrada em cache + saída. Use para planejar o orçamento; o painel do provedor é a referência oficial de cobrança.",
  "footer.tagline": "Faça cada token valer a pena.",
  "footer.updated": "Dados atualizados em {date}",
  "compare.selected": "{count}/3 selecionados",
  "compare.remove": "Remover {name}",
  "compare.button": "Comparar modelos",
  "compare.kicker": "Comparação de modelos",
  "compare.title": "Preços e recursos lado a lado",
  "compare.close": "Fechar",
  "compare.input": "Entrada / MTok",
  "compare.cache": "Cache / MTok",
  "compare.output": "Saída / MTok",
  "compare.monthly": "Custo mensal estimado",
  "compare.context": "Contexto",
  "compare.capabilities": "Raciocínio / ferramentas / visão",
  "compare.docs": "Documentação do provedor",
  "compare.viewPrice": "Ver preços",
  "nav.requestCalculator": "Calculadora de custo por requisição",
  "home.calculatorTitle": "Estimar custo por volume de requisições",
  "home.calculatorBody": "Calcule o gasto mensal com base nas requisições diárias, tokens por requisição e taxa de acerto de cache.",
  "home.compareDirectoryTitle": "Ver comparações de modelos",
  "home.compareDirectoryBody": "Comece por uma comparação selecionada ou crie a sua a partir da tabela de preços.",
  "model.formulaTitle": "Fórmula de custo",
  "model.formulaBody": "Custo mensal = (tokens de entrada sem cache × tarifa de entrada) + (tokens de entrada em cache × tarifa de leitura de cache) + (tokens de saída × tarifa de saída), tudo por milhão de tokens. Sem uma tarifa de leitura de cache publicada, os tokens em cache são estimados pela tarifa de entrada padrão.",
  "model.exampleTitle": "Exemplo reproduzível",
  "model.exampleBody": "Exemplo: {inputM} tokens de entrada ({cachePercent}% vindos do cache) e {outputM} tokens de saída custam {total} nas tarifas publicadas deste modelo — {inputRate} entrada, {cacheRate} entrada em cache, {outputRate} saída por milhão de tokens.",
  "model.calculatorCta": "Estimar custo pelo volume diário de requisições",
  "model.comparisonsTitle": "Presente nestas comparações selecionadas",
};
